<template>
  <BaseGridCard
    v-bind="$attrs"
    :class="[
      'base-grid-card-vertical',
      'd-flex flex-column',
    ]"
    v-on="$listeners"
  >
    <slot name="body"></slot>

    <v-spacer />

    <slot name="footer"></slot>
  </BaseGridCard>
</template>

<script>
import BaseGridCard from "../../baseGridCard/components/BaseGridCard";

export default {
  name: "BaseGridCardVertical",

  components: {
    BaseGridCard,
  },
};
</script>
